import React, { useState } from "react";
import { MdOutlineMenu } from "react-icons/md";
import { IoIosHome } from "react-icons/io";
import { FaCaretRight } from "react-icons/fa6";
import "./Contract.css";
import { FaCaretDown } from "react-icons/fa";
import ButtonPagenate from "../../../Components/ButtonPagenate/ButtonPagenate";
import { getContractData } from "../../../Redux/Actions/contractformdata";
import { Store } from "../../../Redux/store";
import { sidebarTabs } from "../../../Redux/Actions/sidebarButtons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faStar,
  faHandshake,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

const workIcon = {
  icon: <FontAwesomeIcon icon={faBriefcase} />,
  iconStyle: { background: "rgb(33, 150, 243)", color: "#fff", size: 10 },
};

const handshakeIcon = {
  icon: <FontAwesomeIcon icon={faHandshake} />,
  iconStyle: { background: "rgb(16, 204, 82)", color: "#fff", size: 10 },
};

const checkIcon = {
  icon: <FontAwesomeIcon icon={faCheck} />,
  iconStyle: { background: "rgb(33, 150, 243)", color: "#fff", size: 10 },
};

const starIcon = {
  icon: <FontAwesomeIcon icon={faStar} />,
  iconStyle: { background: "rgb(16, 204, 82)", color: "#fff" },
};

const Contract = () => {
  const data = [
    {
      sn: 1,
      status: 1,
      pccReq: "YES",
      agency: "Skyteams Travels And Tours Limited",
      caseNumber: "CF/240324/3807",
      dateRequested: "Mon 22nd - Apr, 2024",
      details: [],
    },
    {
      sn: 2,
      status: 1,
      pccReq: "YES",
      agency: "Falcon Travels",
      caseNumber: "CF/220905/3222",
      dateRequested: "Mon 5th Sep, 2022",
      details: [],
    },
    {
      sn: 3,
      status: 1,
      pccReq: "YES",
      agency: "Travels Etal Ltd",
      caseNumber: "CF/220818/3202",
      dateRequested: "Sat 20th Aug, 2022",
      details: [],
    },
    {
      sn: 4,
      status: 1,
      pccReq: "YES",
      agency: "Primwa Travels",
      caseNumber: "CF/220729/3177",
      dateRequested: "Fri 29th Jul, 2022",
      details: [],
    },
    {
      sn: 5,
      status: 1,
      pccReq: "YES",
      agency: "Cool Trips",
      caseNumber: "CF/220720/3164",
      dateRequested: "Thu 21st Jul, 2022",
      details: [],
    },
    {
      sn: 6,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [],
    },
    {
      sn: 7,
      status: 1,
      pccReq: "YES",
      agency: "Cool Trips",
      caseNumber: "CF/220720/3164",
      dateRequested: "Thu 21st Jul, 2022",
      details: [],
    },
    {
      sn: 8,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [],
    },
    {
      sn: 9,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [],
    },
    {
      sn: 10,
      status: 1,
      pccReq: "YES",
      agency: "Cool Trips",
      caseNumber: "CF/220720/3164",
      dateRequested: "Thu 21st Jul, 2022",
      details: [],
    },
    {
      sn: 11,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [],
    },
    {
      sn: 12,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [],
    },
    {
      sn: 13,
      status: 1,
      pccReq: "YES",
      agency: "Cool Trips",
      caseNumber: "CF/220720/3164",
      dateRequested: "Thu 21st Jul, 2022",
      details: [
        {
          icon: workIcon,
          type: "submitted",
          title: "Contract Form Submitted",
          date: "Sun 24th - Mar, 2024",
          desc: [],
        },
        {
          icon: workIcon,
          type: "approved",
          title: "Contract Form Approved",
          date: "Mon 22nd Apr - 2024 at 12:16 pm",
          desc: [
            "This form was approved by Benjamin Oladapo",
            "New PCC Order Request was generated and sent to HelpDesk email (helpdesk@sabreng.com)",
          ],
        },
        {
          icon: workIcon,
          type: "update",
          title: "Update to this request",
          date: "Thu 25th - Apr, 2024",
          desc: [
            "PE*H7L7/STAGE",
            "LN/ATA TYPE CATEGORY",
            "D84443 CRT STG-*",
            "D84444 CRT STG-*-*",
            "D84445 CRT STG-*",
            "D84446 MINI STGU-S",
          ],
        },
        { icon: starIcon },
      ],
    },
    {
      sn: 14,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [
        {
          icon: workIcon,
          type: "submitted",
          title: "Contract Form Submitted",
          date: "Sun 24th - Mar, 2024",
          desc: [],
        },
        {
          icon: workIcon,
          type: "approved",
          title: "Contract Form Approved",
          date: "Mon 22nd Apr - 2024 at 12:16 pm",
          desc: [
            "This form was approved by Benjamin Oladapo",
            "New PCC Order Request was generated and sent to HelpDesk email (helpdesk@sabreng.com)",
          ],
        },
        {
          icon: workIcon,
          type: "update",
          title: "Update to this request",
          date: "Thu 25th - Apr, 2024",
          desc: [
            "PE*H7L7/STAGE",
            "LN/ATA TYPE CATEGORY",
            "D84443 CRT STG-*",
            "D84444 CRT STG-*-*",
            "D84445 CRT STG-*",
            "D84446 MINI STGU-S",
          ],
        },
        { icon: starIcon },
      ],
    },
    {
      sn: 15,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [
        {
          icon: workIcon,
          type: "submitted",
          title: "Contract Form Submitted",
          date: "Sun 24th - Mar, 2024",
          desc: [],
        },
        {
          icon: workIcon,
          type: "approved",
          title: "Contract Form Approved",
          date: "Mon 22nd Apr - 2024 at 12:16 pm",
          desc: [
            "This form was approved by Benjamin Oladapo",
            "New PCC Order Request was generated and sent to HelpDesk email (helpdesk@sabreng.com)",
          ],
        },
        {
          icon: workIcon,
          type: "update",
          title: "Update to this request",
          date: "Thu 25th - Apr, 2024",
          desc: [
            "PE*H7L7/STAGE",
            "LN/ATA TYPE CATEGORY",
            "D84443 CRT STG-*",
            "D84444 CRT STG-*-*",
            "D84445 CRT STG-*",
            "D84446 MINI STGU-S",
          ],
        },
        { icon: starIcon },
      ],
    },
    {
      sn: 16,
      status: 1,
      pccReq: "YES",
      agency: "Cool Trips",
      caseNumber: "CF/220720/3164",
      dateRequested: "Thu 21st Jul, 2022",
      details: [
        {
          icon: workIcon,
          type: "submitted",
          title: "Contract Form Submitted",
          date: "Sun 24th - Mar, 2024",
          desc: [],
        },
        {
          icon: workIcon,
          type: "approved",
          title: "Contract Form Approved",
          date: "Mon 22nd Apr - 2024 at 12:16 pm",
          desc: [
            "This form was approved by Benjamin Oladapo",
            "New PCC Order Request was generated and sent to HelpDesk email (helpdesk@sabreng.com)",
          ],
        },
        {
          icon: workIcon,
          type: "update",
          title: "Update to this request",
          date: "Thu 25th - Apr, 2024",
          desc: [
            "PE*H7L7/STAGE",
            "LN/ATA TYPE CATEGORY",
            "D84443 CRT STG-*",
            "D84444 CRT STG-*-*",
            "D84445 CRT STG-*",
            "D84446 MINI STGU-S",
          ],
        },
        { icon: starIcon },
      ],
    },
    {
      sn: 18,
      status: 1,
      pccReq: "YES",
      agency: "Rock And Peebles Company Limited",
      caseNumber: "CF/220627/3143",
      dateRequested: "Mon 27th Jun, 2022",
      details: [
        {
          icon: checkIcon,
          type: "submitted",
          title: "Contract Form Submitted",
          date: "Sun 24th - Mar, 2024",
          desc: [],
        },
        {
          icon: handshakeIcon,
          type: "approved",
          title: "Contract Form Approved",
          date: "Mon 22nd Apr - 2024 at 12:16 pm",
          desc: [
            "This form was approved by Benjamin Oladapo",
            "New PCC Order Request was generated and sent to HelpDesk email (helpdesk@sabreng.com)",
          ],
        },
        {
          icon: workIcon,
          type: "update",
          title: "Update to this request",
          date: "Thu 25th - Apr, 2024",
          desc: [
            "PE*H7L7/STAGE",
            "LN/ATA TYPE CATEGORY",
            "D84443 CRT STG-*",
            "D84444 CRT STG-*-*",
            "D84445 CRT STG-*",
            "D84446 MINI STGU-S",
          ],
        },
        { icon: starIcon },
      ],
    },
  ];

  const [visibleRowIndex, setVisibleRowIndex] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const itemsPerpage = 20; //Number of items to be displayed per page
  const pageCount = Math.ceil(data.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;

  const handleShow = (index) => {
    setVisibleRowIndex(visibleRowIndex === index ? null : index);
  };

  const handleShowCaseDetails = (props) => {
    console.log(props);
    Store.dispatch(getContractData(props));
    Store.dispatch(sidebarTabs("moredetails"));
  };

  const newPagenum = (num) => {
    setPageNumber(num);
  };

  const handleSubmit = () => {};

  const [fields, setFields] = useState({
    agencyname: "",
    casenumber: "",
    status: "",
    filterfrom: "",
    filterto: "",
  });

  ///******** Handle Fields Onchange *******///
  const handleLoginChange = (event) => {
    const { name, value } = event.target;
    const re = /^[0-9]+$/;

    if (
      name === "email" ||
      name === "password" ||
      name === "confpass" ||
      name === "fname" ||
      name === "gender"
    ) {
      setFields({ ...fields, [name]: value });
    } else if (name === "phone") {
      if (event.target.value === "" || re.test(event.target.value)) {
        if (event.target.value.length <= 10) {
          setFields({ ...fields, [name]: value });
        }
      }
    } else {
      setFields({ ...fields, [name]: value });
    }
  };

  return (
    <div className="w-full overflow-y-auto flex flex-col gap-2">
      <div className="w-full py-2 flex items-start justify-start gap-1">
        <span className="text-[13px] font-bold">PCC Order Request /</span>
        <IoIosHome size={16} />
      </div>

      <div className="w-full h-full flex gap-5 relative">
        <div className="w-[75%] gap-5 flex flex-col tablets:w-full">
          <div className="w-full flex flex-wrap gap-5 items-center">
            <div className="p-5 flex flex-col justify-center items-center bg-[white] flex-1 h-[150px]  rounded-md">
              <span className="text-[30px] font-bold">46</span>
              <span className="text-[15px] text-center text-[green]">
                TOTAL SUBMISSION
              </span>
            </div>

            <div className="p-5 flex flex-col justify-center items-center bg-[white] flex-1 h-[150px]  rounded-md">
              <span className="text-[30px] font-bold">0</span>
              <span className="text-[15px] text-center text-[#34bff2]">
                UNTREATED SUBMISSION
              </span>
            </div>

            <div className="p-5 flex flex-col justify-center items-center bg-[white] flex-1 h-[150px]  rounded-md">
              <span className="text-[30px] font-bold">46</span>
              <span className="text-[15px] text-center text-[red]">
                TREATED SUBMISSION
              </span>
            </div>
          </div>

          <div className="w-full h-full bg-[#fff] flex flex-col gap-1">
            <div className="w-full p-1 items-center flex flex-wrap gap-2 tablets_min:hidden">
              <input
                className="w-[15%] min-w-[60px] flex-grow p-2 border_class rounded-md outline-none text-[10px] text-[#333] bg-[white]"
                placeholder="Agency Name"
                type="text"
              />

              <input
                className="w-[15%] min-w-[60px] flex-grow p-2 border_class rounded-md outline-none text-[10px] text-[#333] bg-[white]"
                placeholder="Case Number"
                type="text"
              />

              <input
                className="w-[15%] min-w-[60px] flex-grow p-2 border_class rounded-md outline-none text-[10px] text-[#333] bg-[white]"
                placeholder="Filter By"
                type="text"
              />

              <input
                className="w-[15%] min-w-[60px] flex-grow p-2 border_class rounded-md outline-none text-[10px] text-[#333] bg-[white]"
                placeholder="Date From"
                type="text"
              />

              <input
                className="w-[15%] min-w-[60px] flex-grow p-2 border_class rounded-md outline-none text-[10px] text-[#333] bg-[white]"
                placeholder="Date To"
                type="text"
              />

              <input
                type="submit"
                value="Search"
                className="w-[15%] min-w-[60px] p-2 text-[10px] rounded-md border_class flex-grow text-center cursor-pointer bg-[green] text-[#fff]"
              />
            </div>

            <div className="w-full gap-2 flex bg-[#d8d8d8] items-center px-1 py-1">
              <MdOutlineMenu size={25} />
              <span>PCC Order Request</span>
            </div>

            <div className="overflow-x-auto w-full h-[100vh] overflow-y-auto">
              <table className="min-w-full bg-white border border-gray-200 relative">
                <thead>
                  <tr>
                    <th className="py-2 px-4 border-b">SN</th>
                    <th className="py-2 px-4 border-b">Status</th>
                    <th className="py-2 px-4 border-b">PCC Req</th>
                    <th className="py-2 px-4 border-b">Agency</th>
                    <th className="py-2 px-4 border-b">Case Number</th>
                    <th className="py-2 px-4 border-b">Date Requested</th>
                    <th className="py-2 px-4 border-b">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {data
                    .reverse()
                    .slice(pagesVisited, pagesVisited + itemsPerpage)
                    .map((item, index) => (
                      <tr key={index}>
                        <td className="p-2 border-b text-center">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          <div
                            className={`${
                              item.status === 1
                                ? "bg-green-500 text-[#fff]"
                                : ""
                            } px-2 py-2 text-[12px] rounded-md`}
                          >
                            {item.status === 1 ? "Treated" : "Untreated"}
                          </div>
                        </td>

                        <td className="p-2 border-b text-center">
                          {item.pccReq}
                        </td>
                        <td className="p-2 border-b">{item.agency}</td>
                        <td className="p-2 border-b">{item.caseNumber}</td>
                        <td className="p-2 border-b">{item.dateRequested}</td>

                        <td className="p-2 h-full border-b flex justify-center items-center">
                          <button
                            className="bg-blue-500 text-white px-2 min-h-[40px] flex items-center justify-center relative "
                            onClick={() => handleShow(index)}
                          >
                            <span>Actions</span>
                            {visibleRowIndex === index ? (
                              <FaCaretDown size={15} />
                            ) : (
                              <FaCaretRight size={15} />
                            )}

                            {visibleRowIndex === index && (
                              <div
                                className="w-full bg-[white] text-[#333] border absolute top-[40px] p-2 text-[11px] shadow-sm z-20 border_class"
                                onClick={() =>
                                  handleShowCaseDetails(item.details)
                                }
                              >
                                View More
                              </div>
                            )}
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-full flex justify-end">
            <ButtonPagenate
              updatedPageNum={newPagenum}
              pageCount={pageCount}
              pageNumber={pageNumber}
              previousLabel="Prev"
              nextLabel="Next"
            />
          </div>
        </div>

        <form
          className="w-[25%] bg-[#fffeff] flex sticky top-0 flex-col p-3 tablets:hidden"
          onSubmit={handleSubmit}
        >
          <span className="font-bold text-[14px]">Search PCC Requests</span>

          <div className="w-full flex flex-col gap-1 py-2">
            <span className="text-[11px] text-[#333]">Agency Name</span>
            <input
              className="w-full py-2 px-2 border_class outline-none text-[13px]"
              placeholder="Agency Name"
              type="text"
              name="agencyname"
            />
          </div>

          <div className="w-full flex flex-col gap-1 py-2">
            <span className="text-[11px] text-[#333]">Case Number</span>
            <input
              className="w-full py-2 px-2 border_class outline-none text-[13px]"
              placeholder="Agency address e.g. Ikeja or Lekki"
              type="text"
            />
          </div>

          <div className="w-full flex flex-col gap-1 py-2">
            <span className="text-[11px] text-[#333]">Filter by Status</span>
            <input
              className="w-full py-2 px-2 border_class outline-none text-[13px]"
              placeholder="All Submission"
              type="text"
              name="registration"
            />
          </div>

          <div className="w-full flex flex-col gap-1 py-2">
            <span className="text-[11px] text-[#333]">Registration Date</span>

            <div className="w-full gap-2 flex items-center">
              <input
                className="bnw-ligin-password"
                name="registration"
                placeholder="Date From"
                value={fields.filterfrom}
                type="text"
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => (e.target.type = "text")}
                onChange={handleLoginChange}
                required
              />

              <input
                className="bnw-ligin-password"
                name="registration"
                placeholder="Date To"
                value={fields.filterto}
                type="text"
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => (e.target.type = "text")}
                onChange={handleLoginChange}
                required
              />
            </div>
          </div>

          <input
            type="submit"
            value="Search"
            className="p-2 border_class text-center mt-5 cursor-pointer bg-[green] text-[#fff]"
          />
        </form>
      </div>
    </div>
  );
};

export default Contract;
